import React from 'react'
import styled from 'styled-components'
import media from '../../../utils/style'

export const NewsStripEl = styled.div`
  height: 40px;
  display: flex;
  overflow: hidden;
  flex-direction: row-reverse;
  align-items: center;
  background-color: ${(props) => props.theme.colors.grey_lighter};
  color: ${(props) => props.theme.colors.grey_mid};
  font-size: 15px;
  line-height: 1.5;

  ${media.SmallishScreenUp`
    height: 48px;
  `}
`

export const NewsStripItems = styled.div`
  flex: 1 1 auto;
  height: 100%;
  position: relative;
  min-width: 0;
`

export const NewsStripItem = styled(({ active, ...rest }) => <div {...rest} />)`
  opacity: ${(props) => (props.active ? '1' : '0')};
  z-index: ${(props) => (props.active ? '1' : '0')};
  transition: opacity 0.3s 0.5s ease-out;

  ${(props) =>
    !props.active &&
    `
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transition-delay: 0;
  pointer-events: none;
  `}

  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const NewsStripItemContent = styled.div`
  text-overflow: ellipsis;
  padding: 0 10px;
  overflow: hidden;
  white-space: nowrap;
  max-width: 100%;
  min-width: 0;
`

export const NewsStripIcon = styled.span`
  display: inline-block;
  margin-left: 10px;
  width: 15px;
  height: 13px;
  line-height: 13px;

  svg {
    width: 15px;
    height: 13px;
    fill: #acadae;
  }

  ${media.SmallishScreenUp`
    width: 18px;
    height: 15px;
    line-height: 15px;
    svg {
      width: 18px;
      height: 15px;
    }
  `}
`

export const NewsStripHeadline = styled.span`
  font-weight: 600;
`

export const NewsStripDescription = styled.span`
  display: none;
  ${media.SmallishScreenUp`
    display: inline;
    margin-left: 4px;
  `}
`

export const NewsStripButton = styled.a`
  background: transparent;
  cursor: pointer;
  border: 0;
  text-decoration: none;
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  color: inherit;
  transition-duration: 0.1s;

  ${media.SmallishScreenUp`
    opacity: 1;
    position: static;
    width: auto;
    height: auto;
    padding: 0 4px 1px;
    margin-top: 2px;
    flex: 0 0 auto;
    border: 1px solid #747476;
    border-radius: 3px;
    font-size: 13px;

    &:focus,
    &:hover {
      outline: 0;
      border-color: ${(props) => props.theme.colors.blue};
    }
  `};
`

export const NewsStripDismiss = styled.button`
  flex: 0 0 auto;
  background: transparent;
  border: 0;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.3;

  svg {
    width: 14px;
    height: 14px;
    display: block;
    path {
      fill: ${(props) => props.theme.colors.grey_mid};
    }
  }

  &:hover {
    opacity: 1;
  }

  ${media.SmallishScreenUp`
    width: 48px;
    height: 48px;
  `}
`

export const NewsStripImageLink = styled.a`
  display: inherit;
`
